import React from "react";
import { Table, Typography, message } from "antd";
const { Text } = Typography;
import { withRouter } from "react-router-dom";
import moment from "moment";
import { platformApi } from "../../../../api";

const FollowUpTable = (props) => {
  const { pagination, dataSource, spinner, history, tab } = props;

  const handleRowClick = async (record) => {
    try {
      // ✅ Step 1: Get valid service date
      const serviceItem = record?.service?.find((item) => item?.serviceDate);
      const serviceDate = serviceItem?.serviceDate;
      if (!serviceDate) {
        message.error("No valid service date found for this record");
        return;
      }

      // ✅ Step 2: Collect all phone numbers from customer array
      const phoneNumbers = record?.customer
        ?.flatMap((c) =>
          c?.customer?.contacts?.map((ct) => ct?.phone).filter(Boolean)
        )
        .filter(Boolean);

      if (!phoneNumbers?.length) {
        message.error("No phone numbers found for this record");
        return;
      }

      // ✅ Step 3: Loop through phones to find the one that has valid customers in API
      let validPhone = null;

      for (const phone of phoneNumbers) {
        const res = await platformApi.get(`/api/customer/phoneNo/${phone}`);
        const customers = res?.data?.response?.data?.customers || [];
        if (customers.length > 0) {
          validPhone = phone;
          break; // ✅ stop once we find a valid one
        }
      }

      if (!validPhone) {
        message.error("No valid customer found for any phone numbers");
        return;
      }

      // ✅ Step 4: Redirect with the valid phone
      history.push({
        pathname: `/autoadmin/service-followups/${validPhone}/fupdate/${serviceDate}`,
        state: { tab, registerNo: record?.registerNo }
      });
    } catch (err) {
      console.error("Error verifying phone:", err);
      message.error("Error verifying customer phone");
    }
  };

  const columns = [
    {
      title: "Vehicle",
      dataIndex: "registerNo",
      key: "registerNo",
      render: (record) => <span>{record || "-"}</span>,
    },
    {
      title: "Customer Name",
      dataIndex: "customer",
      key: "name",
      render: (record) => (
        <span>{record?.[0]?.customer?.name || "-"}</span>
      ),
    },
    {
      title: "Service No",
      dataIndex: "service",
      key: "serviceNo",
      render: (record) => {
        if (!Array.isArray(record)) return <span>-</span>;
        const item = record.find((i) => i?.serviceNo);
        return <span>{item?.serviceNo || "-"}</span>;
      },
    },
    {
      title: "Service Type",
      dataIndex: "service",
      key: "serviceType",
      render: (record) => {
        if (!Array.isArray(record)) return <span>-</span>;
        const item = record.find(
          (i) => i?.serviceType && i.serviceType !== "null"
        );
        return <span>{item?.serviceType || "-"}</span>;
      },
    },
    {
      title: "Service Kms",
      dataIndex: "service",
      key: "serviceKms",
      render: (record) => {
        if (!Array.isArray(record)) return <span>-</span>;
        return (
          <>
            {record.map((item, i) => (
              <span key={i}>{item?.serviceKms || "-"}</span>
            ))}
          </>
        );
      },
    },
    {
      title: "Mobile No",
      dataIndex: "customer",
      key: "phone",
      render: (record) => {
        const phones = record
          ?.flatMap((c) =>
            c?.customer?.contacts?.map((ct) => ct?.phone).filter(Boolean)
          )
          .filter(Boolean);
        return <span>{phones?.join(", ") || "-"}</span>;
      },
    },
    {
      title: "Next Service Date",
      dataIndex: "service",
      key: "serviceDate",
      render: (record) => {
        if (!Array.isArray(record)) return <span>-</span>;
        const item = record.find((i) => i?.serviceDate);
        return (
          <span>
            {item?.serviceDate
              ? moment(item.serviceDate).format("DD/MM/YYYY")
              : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <Table
      style={{ cursor: "pointer" }}
      pagination={pagination}
      columns={columns}
      dataSource={dataSource || []}
      loading={spinner}
      onRow={(record) => ({
        onClick: () => handleRowClick(record),
      })}
    />
  );
};

export default withRouter(FollowUpTable);